import { z } from 'zod';

export const categoryModelSchema = z.object({
  categoriaId: z.number(),
  nomCategoria: z.string(),
  nomCategoriaAdmin: z.string(),
  modelos: z.array(z.string().nullable()).transform((arr) => arr.filter((m): m is string => m !== null)),
});

export type CategoryModel = z.infer<typeof categoryModelSchema>;

export const categoryModelsResponseSchema = z.array(categoryModelSchema);

export type CategoryModelsResponse = z.infer<typeof categoryModelsResponseSchema>;
